import React from "react";
import "../App";
import { FaFacebook } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import mapImage from "../assets/new-map-image.png";
const Contact = () => {
  const { t } = useTranslation();

  const openMapsHandler = () => {
    window.open(
      "https://maps.app.goo.gl/THgNppKE78JPARYC9",
      "_blank"
    );
  };

  return (
    <div className="contact">
      <div className="contact-heading">
        <h1>{t("contacts-heading")}</h1>
      </div>
      <h3>{t("contacts-heading-small")}</h3>
      <p>{t("contacts-sylvia")}</p>
      <p> {t("contacts-address")}</p>
      <img src={mapImage} alt="#" className="contacts-map-img" />{" "}
      <button className="btn-location" onClick={openMapsHandler}>
        {t("contacts-open-maps-btn")}
      </button>
      <p className="mobile-number">{t("contacts-mobile")}</p>
      <p>
        Email: <span style={{ color: "#f98d2f" }}> sisprevodi@gmail.com</span>
      </p>
      <p>
        Facebook:{" "}
        <span>
          {" "}
          <FaFacebook
            size={40}
            color={"#1678f2"}
            onClick={() =>
              window.open("https://www.facebook.com/silviya.georgieva.148")
            }
            className="facebook-icon"
          />{" "}
        </span>
      </p>
      <p>
        {t("contacts-business-facebook")}
        <span>
          {" "}
          <FaFacebook
            size={40}
            color={"#1678f2"}
            onClick={() =>
              window.open("https://www.facebook.com/silviyageorgieva1980/")
            }
            className="facebook-icon"
          />{" "}
        </span>
      </p>
      <p>
        <b>{t("contacts-teams")}</b> SISEN
      </p>
      <div className="contact-form">
        <form name="contact-form" method="POST" data-netlify="true">
          <input type="hidden" name="form-name" value="contact-form" />
          <input type="hidden" name="form-name" value="contact" />
          <p>
            <label htmlFor="name">
              {t("contacts-name-field")}{" "}
              <span className="required-span">{`(${t("required")})`}</span>
            </label>{" "}
            <br />
            <input type="text" id="name" name="name" required />
          </p>
          <p>
            <label htmlFor="email">
              {t("contacts-email-field")}{" "}
              <span className="required-span">{`(${t("required")})`}</span>
            </label>{" "}
            <br />
            <input type="email" id="email" name="email" required />
          </p>
          <p>
            <label htmlFor="message">{t("contacts-message-field")}</label>{" "}
            <br />
            <textarea id="message" name="message" required></textarea>
          </p>
          <button type="submit">{t("btn-send")}</button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
